import React, { Component } from 'react';
import DocumentStore from '../../components/App/Stores/DocumentStore';
import DocumentDownloader from '../../components/Documents/DocumentDownloader';
import { inject, observer } from 'mobx-react';
import * as TRANSITION from '../../components/App/Constants/Transition';
import * as TELEMETRY from '../../components/App/Constants/Telemetry';
import * as EVENTS from '../../components/App/Constants/Events';

interface Props {
    documentStore: DocumentStore
 }

@inject('documentStore')
@observer
class Documents extends Component<Props> {
  
  private timeout: any;

  constructor(props: Props) {
    super(props);
    props.documentStore.getNZFAPDocumentList();
  }

  
  componentDidMount = () => {
    const element = document.getElementById('c-documents');
    element!.addEventListener(EVENTS.MOUSE_SCROLL, this.trackScrolling.bind(this));
  }

  trackScrolling = (event: any) => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const _node: any = event.target;
      const { documentStore } = this.props;
      const scrollTop = Math.ceil(_node.scrollTop);
      const isBottomOfDiv =
        _node.scrollHeight - scrollTop <= _node.clientHeight;
      const _element = document.getElementById('c-documents');

          if (isBottomOfDiv && !documentStore.isDocListAllLoaded && _node.scrollTop > 0) {
            this.setState({ isDisplayLoadingAnimation: true });
            window.telemetry.logEvent(TELEMETRY.EVENTS.RESOURCE_PAGINATION_LOAD);
            documentStore!.getNZFAPDocumentList()!.then(() => {
              this.setState({ isDisplayLoadingAnimation: false });
              _element!.scrollTop = scrollTop;
            });
          }
    }, TRANSITION.TIMELINE_SCROLL_DELAY);
  }

  render() {
    const {documentStore} = this.props;
    if(documentStore.docList){
    console.log(documentStore.docList);
      return (
        <div className="c-documents" id="c-documents">
          <div className='c-documents__list'>
            <p className='c-documents__list-header'>RESOURCES</p>
            <p className='c-documents__list-subheader'>NZFAP Plus Requirements</p>
            {documentStore.docList.map(document => {
              console.log(document)
              return(<DocumentDownloader document={document} documentStore={documentStore} />)
            })}
          </div>
        </div>
      );
    } else {
      return(
        <div className="c-documents" id="c-documents">
          <div className='c-documents__list'>
            <p className='c-documents__list-header'>RESOURCES</p>
            <p className='c-documents__list-subheader'>NZFAP Plus Requirements</p>
          </div>
        </div>
      )
    }
  }
}

export default Documents;
